import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";

import { FuseSharedModule } from "@fuse/shared.module";

import { ForgotPasswordComponent } from "app/modules/auth/forgot-password/forgot-password.component";
import { LoginComponent } from "app/modules/auth/login/login.component";
import { ResetPasswordComponent } from "app/modules/auth/reset-password/reset-password.component";
import { TranslateModule } from "@ngx-translate/core";

const routes = [
    {
        path: "login",
        component: LoginComponent,
    },
    {
        path: "forgot-password",
        component: ForgotPasswordComponent,
    },
    {
        path: "reset-password",
        component: ResetPasswordComponent,
    },
];

@NgModule({
    declarations: [ForgotPasswordComponent, LoginComponent, ResetPasswordComponent],
    imports: [
        RouterModule.forChild(routes),

        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,

        TranslateModule,

        FuseSharedModule,
    ],
})
export class AuthModule {}
